import template from './sidemenu-item.html';

class Controller {
    /* @ngInject */
    constructor($scope) {
        $scope.$watch(() => {
            if (this.menuCtrl.toggledItem == this.name) {
                this.toggled = true;
            } else {
                this.toggled = false;
            }
            return this.toggled;
        }, value => {
            //console.debug(value, this.name);
        });
    }

    toggle() {
        this.menuCtrl.toggle(this.name);
    }

}

let sidemenuItemComponent = {
    restrict: 'E',
    bindings: {
        name: '@'
    },
    replace: true,
    transclude: true,
    template: template,
    controller: Controller,
    controllerAs: '$item',
    require: {
        menuCtrl: '^sidemenu'
    }
};

export default sidemenuItemComponent;
